import PropTypes from 'prop-types';
import React from 'react';

import { Button, RadioButton } from '@commons/utils/styledLibraryComponents';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import {
  CatalogStepContainer,
  ChoiceButtonContainer,
  ChoiceLabel,
  ChoicesContainer,
  Illustration,
  RadioHoverArea,
  TextContainer,
} from './styledComponents';

/**
 * Step 2 of the external-client creation flow: the catalog empty-state choice screen.
 * The three choices (add later / manual / clone) drive the parent's catalog selection state; the
 * manual and clone pickers and the save itself are owned by the parent wizard.
 * The choices reuse the rounded library Button with a RadioButton indicator as its label.
 */
const CatalogStep = (props) => {
  const { title, subtitle, choices, selectedChoice, onSelectChoice } = props;

  const renderChoiceLabel = (value, label) => (
    <ChoiceLabel>
      <RadioHoverArea>
        <RadioButton selected={selectedChoice} size="small" value={value} />
      </RadioHoverArea>
      {label}
    </ChoiceLabel>
  );

  return (
    <CatalogStepContainer>
      <Illustration alt="external-client-empty-catalog" src={'/images/inpulse/first-order.svg'} />
      <TextContainer>
        <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_BIG_BOLD_HEIGHT_16}>
          {title}
        </Text>
        <Text color={ENUM_COLORS.DARK} font={ENUM_FONTS.TEXT_SMALL_HEIGHT_16}>
          {subtitle}
        </Text>
      </TextContainer>
      <ChoicesContainer>
        {choices.map(({ value, label }) => (
          <ChoiceButtonContainer key={value}>
            <Button
              color={'inpulse-outline'}
              handleClick={() => onSelectChoice(value)}
              label={renderChoiceLabel(value, label)}
            />
          </ChoiceButtonContainer>
        ))}
      </ChoicesContainer>
    </CatalogStepContainer>
  );
};

CatalogStep.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  selectedChoice: PropTypes.string.isRequired,
  onSelectChoice: PropTypes.func.isRequired,
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default CatalogStep;
